export default __webpack_public_path__ + "static/media/crossEnable.58afdebe.svg";